import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { MatDialog, MatPaginator, MatSort } from "@angular/material";
import { SharedService } from "src/app/services/sharedService";
import { AtomDataSource } from "src/app/services/atomTable.datasource";
import { fromEvent, merge } from "rxjs";
import { debounceTime, distinctUntilChanged, tap } from "rxjs/operators";
import { ApplicationService } from "src/app/services/application.service";
import { ApplicationDialogComponent } from "./dialog/application-dialog/application-dialog.component";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "atom-application",
  templateUrl: "./application.component.html",
  styleUrls: ["./application.component.css"],
})
export class ApplicationComponent implements OnInit {
  subscriptionUpdateApplication: any;
  defaultDisplayedColumns: string[] = [
    "name",
    "type",
    "tin",
    "address",
    "city",
    "turnover",
    "division",
    "date",
    "status",
  ];
  openApplicationDisplayedColumns: string[] = [
    "name",
    "type",
    "municipality",
    "date",
    "status",
  ];
  displayedColumns: string[] = [];
  dataSource: AtomDataSource;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild("input_search", { static: false }) input: ElementRef;
  currentFilter = "All Applications";
  displayedFilters: string[] = ["", "", "", ""];
  statusValue;
  reasonType = "DUPLICATE";
  objectFilter = {};
  constructor(
    public translateService: TranslateService,
    public dialog: MatDialog,
    public sharedService: SharedService,
    private applicationService: ApplicationService,
    public router: Router,
    private route: ActivatedRoute
  ) {
    this.translateService
      .get("APPLICATIONS.ALL-APPLICATIONS")
      .subscribe((translated: string) => {
        this.setFilter()
      });

    this.subscriptionUpdateApplication =
      this.sharedService.updateApplicationEmmitter.subscribe((val) => {
        if (val) {
          this.applicationService
            .updateResource("application", val)
            .subscribe((res) => {
              this.loadApplicationTable();
            });
        }
      });

      this.sharedService.getLan$().subscribe(lang => {
        this.setFilter()
      })
  }

  setFilter() {
    this.displayedFilters[0] = this.translateService.instant(
      "APPLICATIONS.OPEN-APPLICATIONS"
    );
    this.displayedFilters[1] = this.translateService.instant(
      "APPLICATIONS.REJECTED-APPLICATIONS"
    );
  
    this.displayedFilters = this.displayedFilters.slice(0, 2);
  
    this.currentFilter = this.translateService.instant(
      "APPLICATIONS.OPEN-APPLICATIONS"
    );
  }

  handleSelection(event) {
    this.statusValue = null;
    this.reasonType = null;
    this.displayedColumns = [...this.openApplicationDisplayedColumns];
    this.objectFilter = {};
  
    if (event.value === this.displayedFilters[0]) {
      this.statusValue = "approval";
      this.objectFilter = { status: "approval" };
    } else if (event.value === this.displayedFilters[1]) {
      this.statusValue = "reject";
      this.objectFilter = { status: "reject" };
    }
  
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      this.paginator.firstPage();
    }
  
    this.dataSource.loadData(
      "application",
      this.reasonType ? { reasonType: this.reasonType } : null,
      "asc",
      "name",
      0,
      this.paginator.pageSize,
      this.objectFilter
    );
  }

  ngOnInit() {
    this.dataSource = new AtomDataSource(this.applicationService);
    this.displayedColumns = [...this.openApplicationDisplayedColumns];
  }

  ngAfterViewInit() {
    setTimeout(() => {
      let tab = this.route.snapshot.queryParamMap.get("tab");
  
      if (tab) {
        this.statusValue = tab;
  
        switch (tab) {
          case "approval":
            this.currentFilter = this.translateService.instant(
              "APPLICATIONS.OPEN-APPLICATIONS"
            );
            this.handleSelection({ value: this.currentFilter });
            break;
  
          case "reject":
            this.currentFilter = this.translateService.instant(
              "APPLICATIONS.REJECTED-APPLICATIONS"
            );
            this.handleSelection({ value: this.currentFilter });
            break;
  
          default:
            this.currentFilter = this.translateService.instant(
              "APPLICATIONS.OPEN-APPLICATIONS"
            );
            this.handleSelection({ value: this.currentFilter });
            break;
        }
      } else {
        this.currentFilter = this.translateService.instant(
          "APPLICATIONS.OPEN-APPLICATIONS"
        );
        this.handleSelection({ value: this.currentFilter });
      }
    }, 0);
  
    this.sort.sortChange.subscribe(() => {});
  
    fromEvent(this.input.nativeElement, "keyup")
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        tap(() => {
          this.paginator.pageIndex = 0;
          this.loadApplicationTable();
        })
      )
      .subscribe();
  
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(tap(() => this.loadApplicationTable()))
      .subscribe();
  }

  loadApplicationTable() {
    this.dataSource.loadData(
      "application",
      this.input.nativeElement.value,
      this.sort.direction,
      this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.objectFilter
    );
  }

  openApplicationView(applicationId) {
    let queryParams = {
      backRoute: "applications",
    };
    if (this.statusValue) {
      queryParams["tab"] = this.statusValue;
    }
    this.router.navigate(["/application/" + applicationId], { queryParams });
  }

  openDialog(type, application): void {
    const dialogRef = this.dialog.open(ApplicationDialogComponent, {
      width: "850px",
      panelClass: "custom-dialog-container",
      data: { type, application: application },
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  ngOnDestroy() {
    if (this.subscriptionUpdateApplication)
      this.subscriptionUpdateApplication.unsubscribe();
  }
}
